import containerFuild from '../html-snippets/container-fuild';
import cssSnippet from '../css-snippets/section-card-statistics-yuri';
const html = `
<div>
  <div class="container">
    <div class="wrap-card">
      <div data-attribute="title-card" data-show="true" class="card-title">
        <h2 style="text-align:center;">Statistics Don't Lie</h2>
        <p style="text-align:center;">Real People, Real Results<br>&nbsp;</p>
      </div>
      <div data-attribute="list-item" class="list-item" data-show="true" data-color-highlight="#cb6387"
        style="--color-highlight: #cb6387;">
        <div data-attribute="item" class="wrap-item">
          <div data-attribute="value-item" class="value-highlight">92%</div>
          <div data-attribute="content-item" class="content-item">
            <h3>Instant Hydration Boost</h3>
            <p>said their skin felt more hydrated and refreshed after the very first night.</p>
          </div>
        </div>

        <div data-attribute="item" class="wrap-item">
          <div data-attribute="value-item" class="value-highlight">95%</div>
          <div data-attribute="content-item" class="content-item">
            <h3>Visible Firmness &amp; Smoothness</h3>
            <p>reported their skin looked smoother, firmer, and more radiant within the first week.</p>
          </div>
        </div>

        <div data-attribute="item" class="wrap-item">
          <div data-attribute="value-item" class="value-highlight">92%</div>
          <div data-attribute="content-item" class="content-item">
            <h3>Morning Glow Confidence</h3>
            <p>said they woke up with a healthy glow that boosted their confidence throughout the day.</p>
          </div>
        </div>
      </div>
      <div data-attribute="hint-block" data-show="true" class="hint-text">
        <div class="icon-hint">
          <img data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/05/08/image-69fdbacb7aed3818f2d07cfa.png" alt="">
        </div>
        <div data-attribute="content-hint" class="content-hint">Based on 11,761+ Customer Reviews</div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, cssSnippet);
